module.exports = "/_next/static/images/image@2x-0a5e2c72ae3f8e29f26f05793a83f282.jpg";